import { render, staticRenderFns } from "./suppliesTable.vue?vue&type=template&id=2d63ef61&scoped=true"
import script from "./suppliesTable.vue?vue&type=script&lang=js"
export * from "./suppliesTable.vue?vue&type=script&lang=js"
import style0 from "./suppliesTable.vue?vue&type=style&index=0&id=2d63ef61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63ef61",
  null
  
)

export default component.exports